// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aW-6","name":"styles_name__3fu7-","phone":"styles_phone__1iY7F"};